<template>
  <DataLayout
    class="DataItemRadio"
    :title="title"
    :information="information"
    :information-label="informationLabel"
  >
    <ForceRerender>
      <v-radio-group
        ref="radioGroup"
        v-model="model"
        :label="label"
        :error="hasError()"
        :error-messages="extractError()"
      >
        <v-radio
          v-for="(option, key) in options"
          :key="key"
          :label="option"
          :value="option"
        />
      </v-radio-group>
    </ForceRerender>
  </DataLayout>
</template>

<script>
import hasError from "~/components/forms/utilities/hasError";
import extractError from "~/components/forms/utilities/extractError";
import createModel from "~/components/forms/utilities/createModel";
import ForceRerender from "~/components/wrappers/ForceRerender";

import DataLayout from "~/components/forms/components/layout/DataLayout";

export default {
  name: "DataItemRadio",
  components: {
    DataLayout,
    ForceRerender,
  },
  props: {
    item: { type: Object, default: () => {} },
    fieldName: { type: String, required: true },
    updateAction: { type: String, default: () => undefined },
    isRequired: { type: Boolean, default: false },
    errors: { type: Array, default: () => [] },
    title: { type: String, default: "" },
    label: { type: String, default: "" },
    options: { type: Array, required: true },
    index: { type: Number, default: undefined },
    information: { type: String, default: "" },
    informationLabel: { type: String, default: "" },
  },
  computed: {
    model: createModel(),
  },
  mounted() {
    this.$nextTick(() => {
      const radioGroup = this.$refs?.radioGroup.$el.querySelector(
        '[role="radiogroup"]'
      );
      radioGroup?.removeAttribute("aria-labelledby");
      radioGroup?.setAttribute("aria-label", this.title);
    });
  },
  methods: {
    hasError,
    extractError,
  },
};
</script>

<style>
.DataItemRadio .v-input legend {
  display: none;
}
</style>
